/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Collapse from './collapse/collapse';
import Commons from './commons';
import './ver-financiacion.css';

const VerFinanciacion = (props) => {
  function sortPromotion(appId, promotions, price) {
    const promotionsForApp = [];
    const gateways = [];
    promotions = _.sortBy(promotions, 'installments');
    promotions.map((promo) => {
      if (promo.promotionOwner.applicationId === appId) {
        if (price) {
          promo.priceInstallment = Math.ceil(
            (((price * promo.interests) / 100) + price) / promo.installments,
          );
        }
        promotionsForApp.push(promo);
      }
    });

    promotionsForApp.map((promoNow) => {
      if (gateways.filter((gateway) => gateway.id === promoNow.gateway.id) <= 0) gateways.push(promoNow.gateway);
    });

    return { promotionsForApp, gateways };
  }

  function sortPromotionByBanks(promotions) {
    const banks = [];

    promotions.map((promo) => {
      if (banks.filter((bank) => bank.id === promo.bank.id) <= 0) banks.push(promo.bank);
    });
    banks.map((bank) => {
      bank.promotions = [];
      promotions.map((promo) => {
        if (promo.bank.id === bank.id) bank.promotions.push(promo);
      });
    });
    return banks;
  }

  function defaultPanelMP(gateway) {
    return (
      <Collapse
        key={`gateaway-mp-${gateway.id}`}
        uniqueId={`gateaway-mp-${gateway.id}`}
        title='Mercado Pago'
        body={(
          <b>
            <a href='https://www.mercadopago.com.ar/cuotas' target='_blank' rel='noopener noreferrer'>
              Ver financiacion
              <i className='fa fa-external-link' />
            </a>
          </b>
        )}
      />
    );
  }

  function customBodyForPromos(bank, uniqueId) {
    const componentsPromos = [];

    // eslint-disable-next-line array-callback-return
    bank.promotions.map((promo, index) => {
      componentsPromos.push(
        // eslint-disable-next-line react/no-array-index-key
        <li key={`promo-${uniqueId}${index}`} className='list-group-item'>
          <div className='img-item'>
            <img
              src={promo.card.imageUrl}
              alt={promo.card.name}
              className='img-response'
              style={{ maxHeight: 20, marginRight: 15 }}
            />
          </div>
          <b>
            {promo.installments}
            {' '}
            Cuota
            { parseInt(promo.installments, 10) > 1 ? 's ' : ' ' }
          </b>
            &nbsp;
          {parseInt(promo.interests, 10) === 0 ? (<span className='sin-interes'>Sin interés</span>) : ' '}
          {promo.priceInstallment ? (
            <>
              {' '}
              <span>&nbsp;de&nbsp;</span>
              <b>
                {' '}
                $
                {Commons.numberToMoney(promo.priceInstallment)}
                {' '}

              </b>
            </>
          ) : null }
          {promo.cft === '' ? null : ` - CFT: ${promo.cft}%`}
          { promo.tna === '' ? null : `TNA: ${promo.tna}%` }
        </li>,
      );
    });
    return <ul className='list-group cards'>{componentsPromos}</ul>;
  }

  function bodyGateway(banksWithPromotions, idGT, uniqueId, index) {
    const contenido = [];

    // eslint-disable-next-line array-callback-return
    banksWithPromotions.map((bank, indexPromo) => {
      let promociones = 0;
      let sinInteres = 0;
      // eslint-disable-next-line array-callback-return
      bank.promotions.map((promo) => {
        if (promo.gateway.id === idGT) promociones++;
        if (parseInt(promo.interests, 10) === 0) sinInteres++;
      });
      if (promociones > 0) {
        const titulo = (
          <React.Fragment>
            <div className='title-content'>
              <div className='img-item'>
                <img data-num={promociones} data-ni={sinInteres} src={bank.imageUrl} alt={bank.denomination} className='img-responsive' />
              </div>
              { sinInteres > 0 ? (<span className='sin-interes'>Hay cuotas sin interés</span>) : null}
            </div>
          </React.Fragment>
        );
        contenido.push(
          <Collapse
            // eslint-disable-next-line react/no-array-index-key
            key={`${uniqueId}-bank-${bank.id}-${index}-${indexPromo}`}
            uniqueId={`${uniqueId}-bank-${bank.id}-${index}-${indexPromo}`}
            title={titulo}
            customBody={customBodyForPromos(bank, uniqueId)}
          />,
        );
      }
    });

    return contenido;
  }

  const { id, uniqueId, appId, promotions, price = false, customText = false, className = '' } = props;
  const { promotionsForApp, gateways } = sortPromotion(appId, promotions, price);
  const banksWithPromotions = sortPromotionByBanks(promotionsForApp);

  const gatewaysComponent = gateways.map((gateway, index) => {
    if (gateway.id === 2) return defaultPanelMP(gateway);
    return (
      <Collapse
        key={`gateway-${gateway.id}`}
        uniqueId={`gateway-${gateway.id}`}
        title={gateway.description}
        open
        body={bodyGateway(banksWithPromotions, gateway.id, uniqueId, index)}
      />
    );
  });

  return (
    <React.Fragment key={id}>
      {Commons.length(promotionsForApp) > 0
        ? (
          <button type='button' className={`btn-financiacion ${className}`} data-toggle='modal' data-target={`#modal-financiacion-${uniqueId}`}>
            {customText || (
              <>
                <span style={{ textDecoration: 'underline' }}> Ver opciones de pago</span>
              </>
            ) }
          </button>
        )
        : null}

      <div className='modal fade' id={`modal-financiacion-${uniqueId}`} tabIndex='-1' role='dialog' aria-labelledby='myModalLabel'>
        <div className='modal-dialog' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <button
                type='button'
                className='close'
                data-dismiss='modal'
                aria-label='Close'
              >
                <span aria-hidden='true'>&times;</span>
              </button>
              <h4 className='modal-title' id='myModalLabel'>Opciones de pago</h4>
            </div>
            <div className='modal-body'>
              {gatewaysComponent}
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-default' data-dismiss='modal'>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = function (store) {
  return {
    promotions: store.promociones.promociones,
  };
};
export default connect(mapStateToProps, null)(VerFinanciacion);
